import NewsLoader from "../news/news_loader";

/**
 * [技業logのデータ取得処理]
 * technologyとgpuの情報を取得しマージ。日付ソートして返却
 */
export class TecLoader {
  private loader:NewsLoader;
  private data_technology;
  private callback;

  constructor(callback) {
    this.callback = callback;
    this.loader = new NewsLoader();
    this.loader.load('/technology/inc/data.json', (json)=> {
      this.data_technology = json;
      this.loader.load('/gpu/inc/data.json', (json)=> this.onData(json));
    });
  }

  /**
   * データ取得完了。結合と日付ソート
   * @private
   * @param {*} json
   * @memberof TecLoader
   */
  private onData(json):void {
    Array.prototype.push.apply(this.data_technology.entry, json.entry);
    this.data_technology.entry.sort(function(a, b){
      if (a.date > b.date) return -1;
      if (a.date < b.date) return 1;
      return 0;
    });
    this.callback(this.data_technology);
  }
}